import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HeadingItem as MenuHeadingItem } from '@atlaskit/menu';
import { overrideStyleFunction, sectionHeaderSpacingStyles } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */
var HeadingItem = function HeadingItem(props) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return null;
  }
  var cssFn = overrideStyleFunction(sectionHeaderSpacingStyles, props.cssFn);

  // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
  return /*#__PURE__*/React.createElement(MenuHeadingItem, _extends({}, props, {
    cssFn: cssFn
  }));
};
export default HeadingItem;